<template>
	<footer>
		<div class="container footer-content">
			<div class="footer-top">
				<div class="footer-top-left">
					<span class="subscribe-newsletter"> Suscribite a nuestro newsletter </span>
					<p>Enterate de todos los nuevos eventos que LineUp Tickets tiene para vos.</p>
				</div>
				<div class="footer-top-right">
					<input
						type="email"
						class="email-newsletter"
						placeholder="Ingresa tu correo electrónico"
						v-model="emailNewsletter"
					/>
					<button @click.prevent="newsletterSubscribe()">Suscribirse</button>
				</div>
			</div>
			<div class="footer-main">
				<div class="footer-main-left">
					<router-link :to="{ name: 'home' }" class="lineup-link">
						<img
							src="../../assets/logos/mate/lineup-black.svg"
							alt="LineUp Tickets"
							class="logo-footer"
						/>
					</router-link>
				</div>
				<div class="footer-main-right">
					<div class="footer-column">
						<span class="footer-column-title">LineUp</span>
						<!-- <router-link :to="{ name: 'home' }" class="footer-column-item">
							<span>¿Cómo funciona?</span>
						</router-link> -->
						<router-link :to="{ name: 'home' }" class="footer-column-item">
							<span>Inicio</span>
						</router-link>
						<router-link :to="{ name: 'contacto' }" class="footer-column-item">
							<span>¡Quiero publicar mi evento!</span>
						</router-link>
						<router-link :to="{ name: 'contacto' }" class="footer-column-item">
							<span>Contacto</span>
						</router-link>
					</div>
					<div class="footer-column">
						<span class="footer-column-title">Eventos</span>
						<router-link :to="{ name: 'categoria-futbol' }" class="footer-column-item">
							<span>Fútbol</span>
						</router-link>
						<router-link
							:to="{ name: 'categoria-basquetbol' }"
							class="footer-column-item"
						>
							<span>Basketball</span>
						</router-link>
						<router-link
							:to="{ name: 'categoria-vida-nocturna' }"
							class="footer-column-item"
						>
							<span>Vida nocturna</span>
						</router-link>
						<router-link :to="{ name: 'eventos' }" class="footer-column-item">
							<span>Todos los eventos</span>
						</router-link>
					</div>
					<div class="footer-column last-column">
						<span class="footer-column-title">Legal</span>
						<!-- <router-link :to="{ name: 'faq' }" class="footer-column-item">
							<span>Preguntas frecuentes</span>
						</router-link> -->
						<router-link
							:to="{ name: 'terminos-y-condiciones' }"
							class="footer-column-item"
						>
							<span>Términos y condiciones</span>
						</router-link>
						<router-link
							:to="{ name: 'politica-de-privacidad' }"
							class="footer-column-item"
						>
							<span>Política de privacidad</span>
						</router-link>
					</div>
					<!-- <div class="footer-column footer-column-right">
						<img src="../../assets/ticketin/Defecto.svg" alt="LineUp Tickets" class="ticketin">
					</div> -->
				</div>
			</div>
			<div class="footer-bottom">
				<div class="copyright">
					<span
						>&copy; {{ new Date().getFullYear() }} LineUp Tickets. All rights
						reserved</span
					>
				</div>
				<div class="socials">
					<a href="https://instagram.com/lineuptickets" target="_blank">
						<i class="bx bxl-instagram"></i>
					</a>
					<a href="https://twitter.com/lineup_tickets" target="_blank">
						<i class="bx bxl-twitter"></i>
					</a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	import axios from "axios";

	export default {
		data() {
			return {
				emailNewsletter: "",
			};
		},
		methods: {
			async newsletterSubscribe() {
				try {
					if (
						/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
							this.emailNewsletter.trim()
						)
					) {
						await axios.post("/WSNewsletterRegistro", {
							NewsletterUsuarioEmail: this.emailNewsletter.trim(),
						});

						this.$store.dispatch(
							"showSuccess",
							"¡Te has suscrito exitosamente a nuestro newsletter!"
						);
						this.emailNewsletter = "";
					} else {
						this.$store.dispatch("showError", "Ingresa un correo electrónico válido");
					}
				} catch (error) {
					this.emailNewsletter = "";
					console.log("Ocurrió un error al suscribirse");
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	footer {
		position: relative;
		width: 100%;
		background-color: var(--color-background-footer);
		background-color: var(--color-white);
		color: var(--color-darker);

		.footer-content {
			z-index: 0;
			@include flex(column, flex-start, flex-start);

			.footer-top {
				padding: 40px 0px 80px 0px;
				width: 100%;
				@include flex(row, space-between, center);

				.footer-top-left {
					@include flex(column, center, flex-start);

					.subscribe-newsletter {
						font-size: 30px;
						font-weight: var(--fw-700);
						font-family: var(--font-sora);
					}

					p {
						margin: 0px;
						font-family: var(--font-sora);
						font-weight: var(--fw-300);
						font-size: 16px;
					}
				}

				.footer-top-right {
					@include flex(row, flex-end, center);

					input.email-newsletter {
						-webkit-appearance: none;
						appearance: none;
						border: none;
						width: 100%;
						padding: 0px 36px 0px 16px;
						font-size: 14px;
						font-weight: var(--fw-400);
						line-height: 1.4em;
						width: 100%;
						min-width: 300px;
						border-radius: 0px;
						outline: none;
						height: 48px;
						color: var(--color-darker);
						border-bottom: 1px solid var(--color-grey);

						&::placeholder {
							// color: rgba(254, 253, 251, 0.2);
							color: var(--color-grey);
							opacity: 1;
						}

						&:-ms-input-placeholder {
							// color: rgba(254, 253, 251, 0.2);
							color: var(--color-grey);
						}

						&::-ms-input-placeholder {
							// color: rgba(254, 253, 251, 0.2);
							color: var(--color-grey);
						}

						&:focus-within {
							@include transition(all 0.2s);
							border-bottom: 1px solid var(--color-darker);
						}
					}

					button {
						@include flex(row, center, center);
						text-decoration: none;
						padding: 0px 30px;
						margin-right: 10px;
						font-size: 11px;
						font-family: var(--font-sora);
						color: var(--color-white);
						font-weight: var(--fw-700);
						line-height: 1.3em;
						letter-spacing: 0.8px;
						text-transform: uppercase;
						background-color: var(--color-dark-btn);
						border: 1px solid var(--color-dark-btn-border);
						// background-color: transparent;
						border: 1px solid rgba(254, 253, 251, 0.2);
						border-radius: 99px;
						margin-left: 14px;
						height: 48px;
						cursor: pointer;
						@include transition(all 0.2s);

						&:hover {
							border-color: var(--color-primary);
							background-color: var(--color-primary);
							color: var(--color-darker);
						}
					}
				}
			}

			.footer-main {
				width: 100%;
				@include flex(row, flex-start, flex-start);
				padding-bottom: 30px;

				.footer-main-left {
					width: 30%;
					padding-right: 20px;
					@include flex(column, flex-start, flex-start);

					.lineup-link {
						@include flex(column, flex-start, flex-start);
						text-decoration: none;

						.logo-footer {
							height: 38px;
							width: auto;
						}
					}
				}

				.footer-main-right {
					width: 70%;
					@include flex(row, flex-end, flex-start);

					.footer-column {
						width: calc(33.33% - 20px);
						@include flex(column, flex-end, flex-start);

						.footer-column-title {
							color: var(--color-grey);
							font-weight: var(--fw-300);
							font-family: var(--font-sora);
							font-size: 14px;
							margin-bottom: 16px;
							line-height: 1em;
						}

						a.footer-column-item {
							text-decoration: none;
							font-size: 14px;
							color: var(--color-darker);
							font-weight: var(--fw-500);
							font-family: var(--font-sora);
							line-height: 1em;
							margin: 11px 0px;
							@include transition(all 0.2s);

							&:hover {
								color: var(--color-grey);
							}
						}

						&.footer-column-right {
							@include flex(column, flex-end, flex-end);
						}

						img.ticketin {
							max-width: 115px;
						}
					}
				}
			}

			.footer-bottom {
				flex: 1;
				@include flex(row, space-between, center);
				width: 100%;
				padding: 40px 0;
				// border-top: 1px solid rgba(254, 253, 251, 0.2);

				.copyright {
					@include flex(row, flex-start, center);

					span {
						color: var(--color-grey);
						font-size: 13px;
						font-family: var(--font-inter) !important;
						font-weight: 500;
					}
				}

				.socials {
					@include flex(row, flex-end, center);

					a {
						text-decoration: none;
						@include flex(row, flex-end, center);
						@include transition(all 0.2s);

						i {
							margin-left: 18px;
							font-size: 22px;
							color: var(--color-grey);
							@include transition(all 0.2s);
						}

						&:hover {
							i {
								color: var(--color-darker);
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1400px) {
		footer {
			.footer-content {
				padding-left: 24px;
				padding-right: 24px;
			}
		}
	}

	@media screen and (max-width: 1180px) {
		footer {
			.footer-content {
				.footer-top {
					padding: 50px 0px 30px 0px;
					@include flex(column, center, center);

					.footer-top-left {
						@include flex(column, center, center);
						padding-bottom: 30px;

						.subscribe-newsletter {
							text-align: center;
						}

						p {
							text-align: center;
						}
					}
				}

				.footer-main {
					padding-top: 30px;

					.footer-main-left {
						display: none;
					}

					.footer-main-right {
						width: 100%;

						.footer-column {
							width: 29%;

							&.footer-column-right {
								width: 13%;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 860px) {
		footer {
			.footer-content {
				.footer-top {
					.footer-top-left {
						.subscribe-newsletter {
							font-size: 24px;
						}

						p {
							font-size: 14px;
						}
					}
				}

				.footer-main {
					.footer-main-right {
						.footer-column {
							width: 33.33%;

							&.footer-column-right {
								display: none;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 730px) {
		footer {
			.footer-content {
				.footer-main {
					.footer-main-right {
						@include flex(column, flex-start, flex-start);
						.footer-column {
							width: 100%;
							margin-bottom: 24px;

							&.last-column {
								margin-bottom: 0px;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 570px) {
		footer {
			.footer-content {
				.footer-top {
					.footer-top-left {
						padding-bottom: 20px;
						width: 100%;

						.subscribe-newsletter {
							font-size: 24px;
							line-height: 1.3em;
							margin-bottom: 5px;
						}

						p {
							font-size: 12px;
							line-height: 1.4em;
						}
					}

					.footer-top-right {
						width: 100%;

						input.email-newsletter {
							min-width: unset;
							padding: 0px 10px 0px 10px;
							height: 40px;
							font-size: 12px;
						}

						button {
							height: 40px;
							margin-left: 5px;
							font-size: 11px;
							padding: 0px 14px;
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 450px) {
		footer {
			.footer-content {
				.footer-bottom {
					padding: 24px 0px;

					.copyright {
						span {
							font-size: 10px;
						}
					}

					.socials {
						a {
							i {
								font-size: 17px;
								margin-left: 10px;
							}
						}
					}
				}
			}
		}
	}
</style>
